$.ajax({
  type: "POST",
  dataType: "jsonP",
  url: "https://api.instagram.com/v1/users/self/media/recent/?access_token=2271370830.97d65fc.22baf49757d5485797782ee7d43ac47e&callback=callbackFunction",
  success: function (result) {
     likeTotali = 0;
     maxLike = 0;
     $.each(result.data, function(index, itemData) {
       if (maxLike < itemData.likes.count){
         maxLike = itemData.likes.count;
       }
     });
     minLike = maxLike - maxLike*(40/100);
     bigImageMax = 5;
     $.each(result.data, function(index, itemData) {

       if ( ( itemData.likes.count >= minLike ) && ( itemData.likes.count <= maxLike ) ) {
         if (bigImageMax > 0 ){
           numero_like = "instagram-image__big";
           bigImageMax --;
         }else{
           numero_like = "instagram-image__small";
         }
       }else{
         numero_like = "instagram-image__small";
       }
       immagine = "<div class=\"instagram-image grid-item " + numero_like + "\">";
         immagine += "<a href=\""+itemData.link+"\" target=\"_blank\">";
           immagine += "<div class=\"instagram-image__picture\" style=\"background: url(" + itemData.images.standard_resolution.url+"); \"></div>";
         immagine += "</a>";
         immagine += "<div class=\"instagram-image__likes\">";
           immagine += "<ul><li><img src=\"./assets/img/icons/heart.svg\" alt=\"Numero di like\"> " + itemData.likes.count + "</li>";
           immagine += "<li><img src=\"./assets/img/icons/message.svg\" alt=\"Numero di messaggi\" > " + itemData.comments.count + "</li></ul>";
         immagine += "</div>";
       immagine += "</div>";
       $(".grid").append(immagine);
     });
  }
});

$(window).on('load', function(){

 setBoxSizes();
 masonryInitialization();

});

$(window).resize( function() {
   setBoxSizes();
   masonryInitialization();
});

function masonryInitialization(){

 var container = document.querySelector('.grid');
 pckry = new Packery( container, {
     "itemSelector": ".grid-item",
     "transitionDuration": '0.4s',
     isInitLayout: false
 } );

 pckry.on( 'click', function( pckryInstance, laidOutItems ) {
     // calculateArea();
 } );
 pckry.layout();
}

function setBoxSizes() {

 var available_space = $('.image').width();
 var min_unit_width = 210
 if ( $(window).width() <= 480){
   var min_unit_width = 150;
 }
 var unit_width;
 var max_unit_per_row = 1;

 if( available_space/6 >= min_unit_width ) {
   unit_width = available_space/6;
   max_unit_per_row = 6;
 } else if( available_space/5 >= min_unit_width ) {
   unit_width = available_space/5;
   max_unit_per_row = 5;
 } else if( available_space/4 >= min_unit_width ) {
   unit_width = available_space/4;
   max_unit_per_row = 4;
 } else if( available_space/3 >= min_unit_width ) {
   unit_width = available_space/3;
   max_unit_per_row = 3;
 } else if( available_space/2 >= min_unit_width ) {
   unit_width = available_space/2;
   max_unit_per_row = 2;
 } else {
   unit_width = available_space;
   max_unit_per_row = 1;
 }

 unit_width = Math.floor( unit_width );

 $(".grid-item").each( function() {
   $(this).outerWidth(unit_width);
   if( $(this).hasClass('instagram-image__big') ) {
     if( max_unit_per_row >= 2 )
       $(this).outerWidth( (unit_width*2) );
     $(this).outerHeight( (unit_width*2) );
   } else {
     $(this).outerHeight(unit_width);
   }
 } );
}



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/instagram.js
 ** module id = 133
 ** module chunks = 0
 **/